import { Link } from 'react-router-dom'
import { DirectionItem, DirectionList } from './style'

export const SimilarDirectionsComponent = ({ flightsList, currentRoute, language }) => {
	return (
		<DirectionList>
			{flightsList.filter(item => item.key !== currentRoute)
				.map(item => (
					<DirectionItem key={item.key}>
						<Link to={`/flights/${item.key}`}>
							{item.name[language]}
						</Link>
					</DirectionItem>
				))
			}
		</DirectionList>
	)
}